// Filters a Cognito access token's full scope string down to the scopes that
// apply to one tenant, plus platform-admin (which applies everywhere).
export default function extractTenantPermissionScopes(scopes, tenant_id) {
  const parts = scopes.split(' ');
  const tenant_related_scopes = parts.filter((scope) =>
    scope.includes(`${tenant_id}/`),
  );
  if (parts.includes('platform-admins/admin'))
    tenant_related_scopes.push('platform-admins/admin');
  return tenant_related_scopes;
}
